/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {DeleteBatchRecordingsResponse} from "../model/delete-batch-recordings-response";
import {DeleteMarkerRequest} from "../model/delete-marker-request";
import {DeleteRecordingOrRecordingGroupBatchRequest} from "../model/delete-recording-or-recording-group-batch-request";
import {DeleteRecordingRequest} from "../model/delete-recording-request";
import {DeleteRecordingResponse} from "../model/delete-recording-response";
import {EventState} from "../model/event-state";
import {ListData} from "../model/list-data";
import {SaveRecordingRequest} from "../model/save-recording-request";
import {Scenario} from "../model/scenario";
import {ScenarioRecording} from "../model/scenario-recording";
import {SetFavoriteMarkerRequest} from "../model/set-favorite-marker-request";
import {SetTrainingSessionLockRequest} from "../model/set-training-session-lock-request";
import {SuccessResponse} from "../model/success-response";
import {TrainingSessionScenarioRecordingArchiveView} from "../model/training-session-scenario-recording-archive-view";
import {UpdateOwnerOfScenarioRecordingRequest} from "../model/update-owner-of-scenario-recording-request";

@Injectable({
    providedIn: "root",
})
export class SimRecordingsService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteBatch(request: DeleteRecordingOrRecordingGroupBatchRequest) {
        return super.post<DeleteBatchRecordingsResponse>(`/api/Recordings/DeleteBatch`, request);
    }

    public deleteMarker(request: DeleteMarkerRequest) {
        return super.post<boolean>(`/api/Recordings/DeleteMarker`, request);
    }

    public deleteRecording(request: DeleteRecordingRequest) {
        return super.post<DeleteRecordingResponse>(`/api/Recordings/DeleteRecording`, request);
    }

    public getRecordingById(recordingId: string) {
        return super.get<ScenarioRecording>(`/api/Recordings/GetRecordingById`, {recordingId: recordingId});
    }

    public getScenarioById(scenarioId: string) {
        return super.get<Scenario>(`/api/Recordings/GetScenarioById`, {scenarioId: scenarioId});
    }
/**
 * Use POST, because url can get very long.
 */ 

    public getScenarioRecordingsByEventIds(eventIds: string[]) {
        return super.post<ScenarioRecording[]>(`/api/Recordings/GetScenarioRecordingsByEventIds`, eventIds);
    }

    public getScenarioRecordingsByIds(scenarioRecordingIds: string[]) {
        return super.post<ScenarioRecording[]>(`/api/Recordings/GetScenarioRecordingsByIds`, scenarioRecordingIds);
    }

    public listTrainingSessionsWithScenarioRecordings(startDate: Date | string, endDate: Date | string, searchTerm: string, owner: string, scenarioId: string, userIds: string[], roomIds: string[], eventStates: EventState[], showFavoritesOnly: boolean, excludeEmpty: boolean, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<TrainingSessionScenarioRecordingArchiveView>>(`/api/Recordings/ListTrainingSessionsWithScenarioRecordings`, {startDate: startDate, endDate: endDate, searchTerm: searchTerm, owner: owner, scenarioId: scenarioId, userIds: userIds, roomIds: roomIds, eventStates: eventStates, showFavoritesOnly: showFavoritesOnly, excludeEmpty: excludeEmpty, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public saveRecording(recordingRequest: SaveRecordingRequest) {
        return super.post<SuccessResponse>(`/api/Recordings/SaveRecording`, recordingRequest);
    }

    public setFavoriteMarker(request: SetFavoriteMarkerRequest) {
        return super.post<boolean>(`/api/Recordings/SetFavoriteMarker`, request);
    }

    public setTrainingSessionLock(request: SetTrainingSessionLockRequest) {
        return super.post<SuccessResponse>(`/api/Recordings/SetTrainingSessionLock`, request);
    }

    public updateOwnerOfScenarioRecording(recordingRequest: UpdateOwnerOfScenarioRecordingRequest) {
        return super.post<SuccessResponse>(`/api/Recordings/UpdateOwnerOfScenarioRecording`, recordingRequest);
    }
}